import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { clearModals, ClearModals } from 'src/actions/modal';
import 'src/modules/modals/Modals.css';

interface DispatchProps {
  clearModals: () => void;
}

interface Props extends DispatchProps {
  modalContent?: JSX.Element;
  className?: string; 
}

interface State {
  modalContent?: JSX.Element;
  className?: string;
}

class ModalContainer extends React.Component <Props, State> {

  modalRoot: Element | null;

  constructor(props: Props) {
    super(props);
    this.showModal = this.showModal.bind(this);
    this.state = {modalContent: undefined};
  }

  public componentWillReceiveProps(nextProps: Props): void {
    this.setState({modalContent: nextProps.modalContent, className: nextProps.className});
    if (nextProps.modalContent) {
      this.showModal();
    }
  }

  public render(): React.ReactNode {
    return (
      <div>
        {this.renderModalPortal()}
      </div>
    );
  }

  private createRoot(): void {
    if (document.getElementsByClassName('modal').length <= 0) {
      this.modalRoot = document.createElement('div');
      this.modalRoot.classList.add('modal');
      document.body.appendChild(this.modalRoot);
      $(this.modalRoot).on('hidden.bs.modal', () => this.destroyRoot());
    } else {
      this.modalRoot = document.getElementsByClassName('modal').item(0);
    }
  }

  private destroyRoot(): void {
    if (this.modalRoot) {
      // tslint:disable-next-line no-any
      ($(this.modalRoot) as any).modal('hide');
      this.modalRoot.remove();
    }

    this.modalRoot = null;
    this.props.clearModals();
  }

  private showModal(): void {
    this.createRoot();
    // tslint:disable-next-line no-any
    ($(this.modalRoot!) as any).modal('show');
  }

  private renderModalPortal(): React.ReactNode {
    return this.modalRoot && this.state.modalContent
      ? ReactDOM.createPortal(
        <div className={'modal-dialog ' + (this.state.className || '')}>
          {React.cloneElement(this.state.modalContent, {
            modalRef: $(this.modalRoot)
          })}
        </div>,
        this.modalRoot
      )
      : null;
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  clearModals: (): ClearModals => (
    dispatch(clearModals())
  )
});

export default connect(null, mapDispatchToProps)(ModalContainer);



// WEBPACK FOOTER //
// ./src/modules/commons/modal-handler/Modal.container.tsx